/*
 *
 * ThankYou constants
 *
 */

export const DEFAULT_ACTION = '/ThankYouPage/DEFAULT_ACTION';

export const TEXT_SUCCESS_ORDER = 'Your order was completed successfully';
export const TEXT_FAIL_ORDER = 'Sorry! Your payment was not successful';



// WEBPACK FOOTER //
// client/containers/ThankYou/constants.js